const config = {
    images: 'https://api.sunny.fr/images/',
    //api: 'http://localhost:4040/'
    api: 'https://api.sunny.fr/',
    googleAnalyticsKey: 'UA-114722910-1'
}

export default config